export const ASCENDING = 'ascending';

export const DESCENDING = 'descending';

export const SORT_DIRECTIONS = {
	[ASCENDING]: 'asc',
	[DESCENDING]: 'desc',
};
